<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';
    import { AttributeDataReadModel } from "@Alternatives/Alternatives/Domain/readmodels";

    @Component({
        props: {
            readModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class AttributeDataView extends Vue
    {
        get rm(): AttributeDataReadModel { return this.$props.readModel as AttributeDataReadModel; }
    }

</script>

<template>
    <div>
        <strong>{{rm.Title}}</strong>
        <div>
            <div v-if="rm.HasValue">
                <div v-if="rm.HasMultipleValues">
                    <ul>
                        <li v-for="v in rm.ValuesAsArray">
                            {{v}}
                        </li>
                    </ul>
                </div>
                <div v-else>
                    <span>{{rm.Value}}</span>
                </div>
            </div>
            <div v-else>
                <span class="text-muted font-italic">Not provided</span>
            </div>
        </div>
        <small class="text-muted">{{rm.Description}}</small>
    </div>
</template>